/**
 * CtaSection — 가입 유도 CTA (Figma 2828:2224)
 *
 * 배경(2828:2226)이 2096×1198로 722px 프레임보다 훨씬 커서 overflow-hidden으로 잘라낸다.
 * 시안에서 배경은 x=-176 · y=-353에 놓여 있다 — 1920 기준 래퍼를 중앙정렬해 재현한다.
 *
 * 색은 landing.css의 --lp-* 변수만 쓴다 (D-07 §1.2 랜딩페이지 예외).
 */
interface Props {
  onStart: () => void;
}

export function CtaSection({ onStart }: Props) {
  return (
    <section className="relative isolate overflow-hidden bg-white">
      {/* ── 배경 (2828:2226) ───────────────────────────────────────────── */}
      {/* export가 원본(2096×1198)이 아니라 CTA 프레임에 잘린 렌더(1920×722)로 나온다.
          즉 시안의 오프셋(x=-176 · y=-353)이 이미 반영돼 있어 프레임을 그대로 채우면 된다. */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute left-1/2 top-0 h-full w-[1920px] -translate-x-1/2">
          <img
            src="/landing/cta-bg.png"
            alt=""
            className="absolute inset-0 size-full max-w-none object-cover"
          />
        </div>
      </div>

      {/* ── 본문 (2828:2230) ───────────────────────────────────────────── */}
      <div className="mx-auto flex w-full max-w-[976px] flex-col items-center gap-6 px-8 py-32 text-center">
        <h2 className="max-w-[768px] text-[40px] font-bold leading-[1.15] tracking-[-1.38px] text-[var(--lp-text)] sm:text-[56px] lg:text-[64px]">
          인테리어, 이제는
          <br />
          <span className="text-[var(--lp-brand)]">다르게</span> 해볼까요!
        </h2>

        <p className="text-base font-bold leading-[1.3] text-[var(--lp-text)] lg:text-lg">
          에이전트를 한번 사용해 보고 싶으신가요?
          <br />
          인디피아 Pro로 로그인하시면 바로 시작할 수 있습니다.
        </p>

        <div className="flex flex-col items-center justify-center">
          <button type="button" onClick={onStart} className="lp-btn-brand">
            인디피아 Pro 스튜디오 입장하기
            <img src="/landing/ic-arrow.svg" alt="" className="size-5" />
          </button>
          <p className="px-7 py-4 text-base font-semibold leading-none text-[var(--lp-text)]">
            출시 이벤트로 무료 체험 · 언제든지 해지 가능
          </p>
        </div>

        <div className="mt-3 flex flex-col items-center gap-2">
          <p className="text-xs font-medium leading-none text-[var(--lp-text)]">
            현장에서는 앱으로 바로 이어서 사용하세요
          </p>
          <div className="flex flex-wrap items-start justify-center gap-3">
            <a href="#" className="lp-store-link">
              <img src="/landing/ic-googleplay.png" alt="" className="size-6" />
              Google Play
            </a>
            <a href="#" className="lp-store-link">
              <img src="/landing/ic-appstore.svg" alt="" className="size-6" />
              App Store
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
